import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { parsePageParam } from '#src/app/pages/petitionGuides/category/details/shared/utils';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import type { MergedState } from '#src/app/shared/hooks/state';
import { useMergedStates } from '#src/app/shared/hooks/state';
import { getQueryStringSingleValue } from '#src/app/shared/utils/query';

import { prefetchPetitionGuidesCategoryPageDataFromApi, usePetitionGuidesCategoryPageDataFromApi } from './pageData';

export type PetitionGuidesCategoryPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof usePetitionGuidesCategoryPageDataFromApi>[0]>;
}>;

export type PetitionGuidesCategoryPageCombinedState = MergedState<
	ReturnType<typeof usePetitionGuidesCategoryPageDataFromApi>
>;

export function usePageContext(
	slug: string,
	prefetchedData?: PetitionGuidesCategoryPagePrefetchedContext,
): PetitionGuidesCategoryPageCombinedState {
	const page = parsePageParam(useQueryParamValue('page'));
	return useMergedStates(usePetitionGuidesCategoryPageDataFromApi(prefetchedData?.pageData, slug, page));
}

export async function prefetchPageContext(
	slug: string,
	context: PrefetchContext,
): Promise<PetitionGuidesCategoryPagePrefetchedContext> {
	const page = parsePageParam(getQueryStringSingleValue(context.query, 'page'));
	const [pageData] = await Promise.all([prefetchPetitionGuidesCategoryPageDataFromApi(context, slug, page)]);

	return { pageData };
}

export type PetitionGuidesCategoryPagePrefetchedDataProps =
	PrefetchedDataProps<PetitionGuidesCategoryPagePrefetchedContext>;
